import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=3109d0f4&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./FeedbackPage.vue?vue&type=style&index=0&id=3109d0f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109d0f4",
  null
  
)

export default component.exports